import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import "react-datepicker/dist/react-datepicker.css";
import { translate } from '../../Services/translation';
import { setDeliveryDetailsValues } from '../../Actions/Configurator.action';
import { googleAnalyticsProductConfigurator } from '../../Services/googleAnalytics';
import DatePicker from 'react-datepicker';
import isHoliday from '../../Services/HolidayCheck';
import { toBaseDateFormat, toCurrentLocaleFormat } from '../../Services/formatting';
import { subDays } from 'date-fns';

const PanelDeliveryDate = ({ setting, labelKey, icon, startDate }) => {
  const dispatch = useDispatch(),
    configurator = useSelector((state) => state.configurator),
    cart = useSelector((state) => state.cart),
    { id, delivery, deliveryDetails, orderRow } = configurator;

  const isUpdateMode = orderRow ? true : false;
  const startDateObj = startDate ? new Date(startDate) : new Date();

  const deliveryDate = (deliveryDetails && deliveryDetails.deliveryDate) ? new Date(deliveryDetails.deliveryDate) : null;
  let publicHolidays = (cart.holidays || []).filter(holiday => holiday.isPublicHoliday).map(holiday => holiday.holidayDate);
  let nonPublicHolidays = (cart.holidays || []).filter(holiday => !holiday.isPublicHoliday).map(holiday => holiday.holidayDate);

  const update = (selectedDate) => {
    if (selectedDate !== null) {
      const formattedDate = toBaseDateFormat(selectedDate);
      dispatch(setDeliveryDetailsValues({ [setting]: formattedDate }));
      googleAnalyticsProductConfigurator('deliveryDate', formattedDate, id);
    }
  };

  const getIconPath = () => {
    return '/ui/images/sprites/be-group.svg#' + icon;
  };

  return (
    <section className='configurator-box'>
      <header>
        <svg className='configurator-box__icon'>
          <use href={getIconPath()}></use>
        </svg>
        <h4 className='configurator-box__title'>{translate(labelKey)}</h4>
        {isUpdateMode && (
          <div className='configurator-deliverydate'>
            <DatePicker
              selected={deliveryDate}
              filterDate={(day) => !isHoliday(day, subDays(startDateObj, 1), publicHolidays, nonPublicHolidays)}
              popperPlacement="bottom-end"
              onChange={(date) => update(date)}
              customInput={
                <button className='date-picker-button'>
                  {deliveryDate ? toCurrentLocaleFormat(deliveryDate) : translate('singledate.placeholder')}
                  <svg viewBox="0 0 1393 1500" xmlns="http://www.w3.org/2000/svg">
                    <path d="m107 1393h241v-241h-241zm295 0h268v-241h-268zm-295-295h241v-268h-241zm295 0h268v-268h-268zm-295-321h241v-241h-241zm616 616h268v-241h-268zm-321-616h268v-241h-268zm643 616h241v-241h-241zm-322-295h268v-268h-268zm-294-723v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm616 723h241v-268h-241zm-322-321h268v-241h-268zm322 0h241v-241h-241zm27-402v-241c0-7-3-14-8-19-6-5-12-8-19-8h-54c-7 0-13 3-19 8-5 5-8 12-8 19v241c0 7 3 14 8 19 6 5 12 8 19 8h54c7 0 13-3 19-8 5-5 8-12 8-19zm321-54v1072c0 29-11 54-32 75s-46 32-75 32h-1179c-29 0-54-11-75-32s-32-46-32-75v-1072c0-29 11-54 32-75s46-32 75-32h107v-80c0-37 13-68 40-95s57-39 94-39h54c37 0 68 13 95 39 26 26 39 58 39 95v80h321v-80c0-37 13-69 40-95 26-26 57-39 94-39h54c37 0 68 13 94 39s40 58 40 95v80h107c29 0 54 11 75 32s32 46 32 75z"></path>
                  </svg>
                </button>
              }
            />
          </div>
        )}
      </header>
      <div className='configurator-box__content'>
        {translate('yourdeliverdays')}
        {delivery && delivery.websiteStringModeOfDelivery}
      </div>
    </section>
  );
};

export default PanelDeliveryDate;